import {css, StyleSheet} from 'aphrodite';
import PropTypes from 'prop-types';
import React from 'react';

import {REQUEST_STATUS_NAMES, REQUEST_STATUSES, RequestStatus} from 'requests/RequestConstants';
import {RequestStatusIcon} from 'requests/RequestStatusIcon';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface RequestStatusDropdownProps {
  isDisabled: boolean;
  buttonStyle: ButtonStyle;
  requestStatus?: RequestStatus;
  onUpdateRequestStatus: (newStatus: RequestStatus) => void;
}

interface State {
  open: boolean;
}

// TODO: Replace when D13834 lands
class RequestStatusDropdown extends React.Component<RequestStatusDropdownProps, State> {
  static propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    buttonStyle: PropTypes.oneOf(Object.values(ButtonStyle)).isRequired,
    requestStatus: PropTypes.oneOf(REQUEST_STATUSES),
    onUpdateRequestStatus: PropTypes.func.isRequired,
  };

  override state: State = {
    open: false,
  };

  override render(): JSX.Element {
    return (
      <div className="buttonGroup u-display-inline-block dropdown">
        <AbsoluteDropdownContainer
          open={this.state.open}
          onRequestClose={() => {
            this.setState({open: false});
          }}
          menu={
            <ul className="dropdown-menu fixed-width-icons pull-right">
              {REQUEST_STATUSES.map((requestStatus) => (
                <li key={requestStatus}>
                  <a
                    onClick={() => {
                      this.props.onUpdateRequestStatus(requestStatus);
                    }}
                  >
                    <div className="requestSampleStatusCounts-iconCount">
                      <RequestStatusIcon status={requestStatus} />
                      {REQUEST_STATUS_NAMES[requestStatus]}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          }
          shouldCloseOnInsideClick={true}
        >
          <Button
            buttonStyle={this.props.buttonStyle}
            isDropdown={true}
            onClick={() => {
              this.setState({open: true});
            }}
            size={ButtonSize.SMALL}
            text={this.props.requestStatus ? REQUEST_STATUS_NAMES[this.props.requestStatus] : 'Set status'}
            disabled={this.props.isDisabled}
            icon={
              this.props.requestStatus ? (
                <RequestStatusIcon status={this.props.requestStatus} className={css(styles.statusIcon)} />
              ) : undefined
            }
            dataTestAttrs={{component: 'RequestStatusDropdown', element: 'dropdownToggleButton'}}
          />
        </AbsoluteDropdownContainer>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  statusIcon: {
    marginTop: '2px',
  },
});

export default RequestStatusDropdown;
